export default __webpack_public_path__ + "static/media/info-alert-icon.43281e00.svg";